import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../../components/calendar/Calendar";
import RadioButton from "../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../utils/Utils"
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import Input from "../../../../../../components/textbox/Input";

class SezioneCinque extends Component {

    state = {
        sezioneCinque: {
            doseA: "",
            listaDosi: [
                {tipoDoseA: "", dataDoseA: ""},
                {tipoDoseA: "", dataDoseA: ""}
            ],
            corretto: []
        },
        controlloAutocomplete:{
            tipoDoseA0:true,
            tipoDoseA1:true
        }
    }


    constructor(props) {
        super(props);
        this.riceviValoreInput = this.riceviValoreInput.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneCinque) {
            let sezioneCinque = this.state.sezioneCinque
            let controlloAutocomplete=this.state.controlloAutocomplete
            let propsSezione = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneCinque));
            sezioneCinque.doseA = propsSezione.doseA
            if (propsSezione.listaDosi) {
                for (let i = 0; i < propsSezione.listaDosi.length; i++) {
                    sezioneCinque.listaDosi[i].tipoDoseA = propsSezione.listaDosi[i].tipoDoseA ? propsSezione.listaDosi[i].tipoDoseA : ""
                    sezioneCinque.listaDosi[i].dataDoseA = propsSezione.listaDosi[i].dataDoseA ? propsSezione.listaDosi[i].dataDoseA : ""
                }
                controlloAutocomplete.tipoDoseA0=sezioneCinque.listaDosi[0].tipoDoseA && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[sezioneCinque.listaDosi[0].tipoDoseA] ? true : false
                controlloAutocomplete.tipoDoseA1=sezioneCinque.listaDosi[1].tipoDoseA && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[sezioneCinque.listaDosi[1].tipoDoseA] ? true : false


            }
            this.setState({sezioneCinque: sezioneCinque, controlloAutocomplete: controlloAutocomplete})
        }
        this.controllaDati();
        this.props.setSezioneCinque(this.state.sezioneCinque);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati()
        if (prevState !== this.state) {
            let res = this.createJsonBackend()
            this.props.setSezioneCinque(this.state.sezioneCinque, this.validate(), res)
        }

    }

    validate() {
        if (this.state.sezioneCinque.listaDosi[0].dataDoseA) {
            let validateDataListaDose = Utils.checkDateInterval(this.state.sezioneCinque.listaDosi[0].dataDoseA, "31/12/1899");
            let validateDataOdiernaLista = Utils.checkDateInterval(this.state.sezioneCinque.listaDosi[0].dataDoseA, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validateDataListaDose) {
                return "Messages.DataListaDose"
            } else if (!validateDataOdiernaLista) {
                return "Messages.DataListaDoseOdierna"
            }
        }
        if (this.state.sezioneCinque.listaDosi[1].dataDoseA) {
            let validateDataListaDose = Utils.checkDateInterval(this.state.sezioneCinque.listaDosi[1].dataDoseA, "31/12/1899");
            let validateDataOdiernaListaDose = Utils.checkDateInterval(this.state.sezioneCinque.listaDosi[1].dataDoseA, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validateDataListaDose) {
                return "Messages.DataListaDose"
            } else if (!validateDataOdiernaListaDose) {
                return "Messages.DataListaDoseOdierna"
            }
        }

        if (this.state.sezioneCinque.doseA !== "02" && this.state.sezioneCinque.doseA !== "03") {
            if (this.state.sezioneCinque.listaDosi[0].tipoDoseA) return "Messages.ERR_01_02_0D_0V"
            else if (this.state.sezioneCinque.listaDosi[0].dataDoseA) return "Messages.ERR_01_02_0D_0Z"
        } else if (this.state.sezioneCinque.doseA !== "03") {
            if (this.state.sezioneCinque.listaDosi[1].tipoDoseA) return "Messages.ERR_01_02_0D_AA"
            else if (this.state.sezioneCinque.listaDosi[1].dataDoseA) return "Messages.ERR_01_02_0D_AB"
        }


        return ""

    }

    createJsonBackend() {
        let ObjectForBackEnd = {}
        let dati = JSON.parse(JSON.stringify(this.state.sezioneCinque))
        ObjectForBackEnd["doseA"] = dati.doseA
        ObjectForBackEnd["listaDosi"] = Utils.removeEmptyValueFromObject(dati.listaDosi)
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res
    }

    controllaDati() {

        let dati = this.state.sezioneCinque
        dati.corretto = []

        if(dati.doseA === "02" && !dati.listaDosi[0].tipoDoseA) dati.corretto[0] = "Campo \"Se sì, 1° dose - tipo vaccino\" mancante";
        if(dati.doseA === "02" && (!dati.listaDosi[0].dataDoseA || (dati.listaDosi[0].dataDoseA && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[0].dataDoseA), "-")))) dati.corretto[1] = "Campo \"Data\" mancante o errato";
        if(dati.doseA === "03" && (!dati.listaDosi[0].tipoDoseA || !dati.listaDosi[1].tipoDoseA)) dati.corretto[2] = "Campo \"Se sì, 1° dose - tipo vaccino\" o \"Se sì, 2° dose - tipo vaccino\" mancante";
        if(dati.doseA === "03" && ((!dati.listaDosi[0].dataDoseA || (dati.listaDosi[0].dataDoseA && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[0].dataDoseA), "-")))
                || (!dati.listaDosi[1].dataDoseA || (dati.listaDosi[1].dataDoseA && Utils.isDateInValid(Utils.transformDateForBackend(dati.listaDosi[1].dataDoseA), "-"))))) dati.corretto[3] = "Campo \"Data\" mancante o errato";

    }

    riceviValoreRadioButton(event, field) {
        let sezioneCinque = this.state.sezioneCinque
        sezioneCinque[field] = event

        this.setState({sezioneCinque: sezioneCinque})
    }
    riceviValoreInput(field, event) {

        let sezioneCinque = this.state.sezioneCinque
        let controlloAutocomplete=this.state.controlloAutocomplete
        if (field.currentTarget) {
            if (field.currentTarget.id.includes("dataDoseA")) {
                let indice = parseInt(field.currentTarget.id.replace("dataDoseA", ""))
                sezioneCinque.listaDosi[indice].dataDoseA = field.currentTarget.value
            } else {
                sezioneCinque[field.currentTarget.id] = field.currentTarget.value
            }
        } else {
            if (field.includes("tipoDoseA")) {
                let indice = parseInt(field.replace("tipoDoseA", ""))
                if (!event.target.value) {
                    if(indice===0) controlloAutocomplete.tipoDoseA0 = true
                    else if (indice===1) controlloAutocomplete.tipoDoseA1=true

                }
                sezioneCinque.listaDosi[indice].tipoDoseA = event.target.value

            } else {

                sezioneCinque[field] = event.target.value
            }
        }
        this.setState({sezioneCinque: sezioneCinque,controlloAutocomplete: controlloAutocomplete})
    }

    render() {

        const {t} = this.props;

        const sezioneCinque = (
            <div style={{marginTop: "10px"}}>
                <div>
                    <h6>Sezione 5</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.domandaUno")}</b>

                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="row">
                                <RadioButton id={"doseA1"}
                                             name={"doseA"} label={t("SchedaEpatite.risposteTipoUno.no")}
                                             value={"01"}
                                             onClick={() => this.riceviValoreRadioButton("01", "doseA")}
                                             checked={this.state.sezioneCinque.doseA === "01"}>
                                </RadioButton>
                                <RadioButton id={"doseA2"}
    name={"doseA"} label={"Si, una dose"}
    value={"02"}
    onClick={() => this.riceviValoreRadioButton("02", "doseA")}
    checked={this.state.sezioneCinque.doseA === "02"}
    />
                                <RadioButton id={"doseA3"}
    name={"doseA"} label={"Si, due dosi"}
    value={"03"}
    onClick={() => this.riceviValoreRadioButton("03", "doseA")}
    checked={this.state.sezioneCinque.doseA === "03"}
    />
                                <RadioButton id={"doseA4"}
    name={"doseA"} label={t("SchedaEpatite.risposteTipoUno.nonso")}
    value={"04"}
    onClick={() => this.riceviValoreRadioButton("04", "doseA")}
    checked={this.state.sezioneCinque.doseA === "04"}
    />
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.primaDose")}</b>
                                {(this.state.sezioneCinque.doseA === "02" || this.state.sezioneCinque.doseA === "03") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px", height: "50px"}}>
                            {(this.state.sezioneCinque.listaDosi[0].tipoDoseA && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[this.state.sezioneCinque.listaDosi[0].tipoDoseA]) || !this.state.sezioneCinque.listaDosi[0].tipoDoseA || this.state.controlloAutocomplete.tipoDoseA0 ?

                            <SelectAutocomplete
                                id={"tipoDoseA0"}
                                field={"tipoDoseA0"}
                                newSelect={true}
                                onChange={this.riceviValoreInput}
                                value={this.state.sezioneCinque.listaDosi[0].tipoDoseA}
                                functionMap={Utils.sortByKey(OggettiUtili.tipoVaccino,"descrizione").map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}/>
                            :
                            <Input
                                id="tipoDoseA0"
                                onChange={this.riceviValoreInput}
                                field={"tipoDoseA0"}
                                // errorMessage={"sezione non valido"}
                                value={this.state.sezioneCinque.listaDosi[0].tipoDoseA}
                                placeholder={"Tipo vaccino"}
                            >
                            </Input>
                            }
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.quando")}</b>
                                {(this.state.sezioneCinque.doseA === "02" || this.state.sezioneCinque.doseA === "03") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>
                            <Calendar
                                id="dataDoseA0"
                                field={"dataDoseA0"}
                                value={this.state.sezioneCinque.listaDosi[0].dataDoseA}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneCinque.listaDosi[0].dataDoseA === "" ||
                                    this.state.sezioneCinque.listaDosi[0].dataDoseA == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneCinque.listaDosi[0].dataDoseA), "-")}>
                            </Calendar>
                        </div>

                    </div>
                    <div className="row" style={{marginTop: "10px"}}>
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.secondaDose")}</b>
                                {(this.state.sezioneCinque.doseA === "03") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px", height: "50px"}}>
                            {(this.state.sezioneCinque.listaDosi[1].tipoDoseA && Utils.arrayToMap(OggettiUtili.tipoVaccino, "codice")[this.state.sezioneCinque.listaDosi[1].tipoDoseA]) || !this.state.sezioneCinque.listaDosi[1].tipoDoseA || this.state.controlloAutocomplete.tipoDoseA1 ?

                            <SelectAutocomplete
                                id={"tipoDoseA1"}
                                field={"tipoDoseA1"}
                                newSelect={true}
                                onChange={this.riceviValoreInput}
                                value={this.state.sezioneCinque.listaDosi[1].tipoDoseA}
                                functionMap={Utils.sortByKey(OggettiUtili.tipoVaccino,"descrizione").map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}/>
                            :
                            <Input
                                id="tipoDoseA1"
                                onChange={this.riceviValoreInput}
                                field={"tipoDoseA1"}
                                value={this.state.sezioneCinque.listaDosi[1].tipoDoseA}
                                placeholder={"Tipo vaccino"}
                            >
                            </Input>
                            }

                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                <b>{t("SchedaEpatite.sezione5.quando")}</b>
                                {(this.state.sezioneCinque.doseA === "03") ?
                                    <span className={styles.mandatoryColor}>*</span> : ""}
                            </p>
                        </div>
                        <div className="col-lg-3" style={{paddingLeft: "0px", paddingRight: "0px"}}>

                            <Calendar
                                id="dataDoseA1"
                                field={"dataDoseA1"}
                                value={this.state.sezioneCinque.listaDosi[1].dataDoseA}
                                onChange={this.riceviValoreInput}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    "Data")}
                                error={(this.state.sezioneCinque.listaDosi[1].dataDoseA === "" ||
                                    this.state.sezioneCinque.listaDosi[1].dataDoseA == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.sezioneCinque.listaDosi[1].dataDoseA), "-")}>
                            </Calendar>

                        </div>

                    </div>

                </div>
            </div>
        );


        return <div>

            {sezioneCinque}
        </div>
    }


}

export default withTranslation('common')(SezioneCinque)
